import { render, staticRenderFns } from "./TurnoverChart.vue?vue&type=template&id=5a8a6e16&"
import script from "./TurnoverChart.vue?vue&type=script&lang=js&"
export * from "./TurnoverChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports